var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-home"},[_c('div',{staticClass:"big-title"},[_vm._v("跨国公司投资广东年会")]),_c('div',{staticClass:"success-body"},[_c('img',{attrs:{"src":_vm.tipsIcon}}),_c('div',{staticClass:"success-tip"},[_vm._v("提交成功")])])])}
var staticRenderFns = []

export { render, staticRenderFns }